import request from '@/utils/request'

export function v80a1050List(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/v80a1050/v80a1050List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

